module.exports = __webpack_public_path__ + "img/Icon-21.b6bc0eae.png";